/* 🤖 this file was generated by svg-to-ts */
export const matIconWarehouse: {
  name: 'warehouse';
  data: string;
} = {
  name: 'warehouse',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 8.35V19h-2v-8H6v8H4V8.35l8-3.2 8 3.2zM22 21V7L12 3 2 7v14h6v-8h8v8h6zm-11-2H9v2h2v-2zm2-3h-2v2h2v-2zm2 3h-2v2h2v-2z"/></svg>`
};
